import styled from 'styled-components/native'

export const ActivityName = styled.Text<{
  highlightcolor: string
}>`
  color: ${({ highlightcolor }) => highlightcolor || '#fff'};
  flex-grow: 1;
  margin: 4px 6px 0 28px;
  width: 300px;
  max-width: 100%;
  overflow: hidden;
`


